/** Buton ▶ pentru mostre de voce — folosește sampleUrl sau GET /voices/:id/sample. */
import { useRef, useState } from 'react';
import { api } from '../api/client';
import { resolveMediaUrl } from '../lib/media';

let sharedAudio: HTMLAudioElement | null = null;

export function VoicePlayButton({
  voiceId,
  sampleUrl,
  label,
  size = 'sm',
}: {
  voiceId: string;
  sampleUrl?: string | null;
  label?: string;
  size?: 'sm' | 'md';
}) {
  const [busy, setBusy] = useState(false);
  const [playing, setPlaying] = useState(false);
  const localRef = useRef<HTMLAudioElement | null>(null);

  async function play(e: React.MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      let url = sampleUrl ? resolveMediaUrl(sampleUrl) ?? sampleUrl : null;
      if (!url) {
        const res = await api.get<{ url: string | null }>(`/api/v1/voices/${voiceId}/sample`);
        url = res.url ? resolveMediaUrl(res.url) ?? res.url : null;
      }
      if (!url) {
        setBusy(false);
        return;
      }
      if (sharedAudio) {
        sharedAudio.pause();
        sharedAudio = null;
      }
      const a = new Audio(url);
      localRef.current = a;
      sharedAudio = a;
      a.onended = () => setPlaying(false);
      a.onpause = () => setPlaying(false);
      setPlaying(true);
      await a.play();
    } catch {
      setPlaying(false);
    } finally {
      setBusy(false);
    }
  }

  function stop(e: React.MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    localRef.current?.pause();
    if (sharedAudio === localRef.current) sharedAudio = null;
    setPlaying(false);
  }

  const pad = size === 'md' ? '8px 12px' : '4px 10px';
  const fontSize = size === 'md' ? 13 : 11;

  return (
    <button
      type="button"
      className="btn btn-ghost btn-sm"
      data-testid={`voice-play-${voiceId}`}
      aria-label={playing ? `Oprește ${label ?? 'mostra'}` : `Ascultă ${label ?? 'mostra'}`}
      onClick={playing ? stop : play}
      disabled={busy}
      style={{ padding: pad, fontSize, flex: 'none', minWidth: 36 }}
    >
      {busy ? '…' : playing ? '■' : '▶'}
    </button>
  );
}
